import {
  FinanceType,
  PaymentInOutFlowType,
  PaymentOption,
  PndType,
  TaxIncomeType,
  TransactionType,
  WhtAmountType,
  WhtDeductType,
} from "@/enums/enums";
import { IsOrdinaryPerson } from "./merchantHelper";
import peakUtility from "./peakUtility";
import { GetWhtAmountValue } from "./shareHelper";
import { DoGetTransactionItemList, DoGetTransactionItemSummary } from "./transactionItemHelper";

function GetCreatePaymentTransactionBankAccountDefault() {
  const paymentTransactionBankAccount = {
    bankAccountId: 0,
    bankAccountCode: "",
    bankAccountName: "",
    paymentAmount: "0.00",
    remark: "",
    isCheque: false,
    cheque: {
      id: 0,
      chequeNumber: "",
      chequeDate: Date(),
      branchNumber: "",
      accountNumber: "",
      chequeBankId: 0,
    },
    inputValidationError: false,
  };
  return paymentTransactionBankAccount;
}
function GetCreatePaymentTransactionChartAccountDefault() {
  const paymentTransactionChartAccount = {
    accountId: 0,
    accountCode: "",
    accountName: "",
    paymentAmount: "0.00",
    remark: "",
    adjustValue: 1,
    inputValidationError: false,
  };
  return paymentTransactionChartAccount;
}
function GetCreatePaymentTransactionDocumentDefault() {
  const paymentTransactionDocument = {
    transactionId: 0,
    transactionType: 0,
    transactionNumber: "",
    paymentAmount: "0.00",
    remark: "",
  };
  return paymentTransactionDocument;
}

function GetCreateTransactionPaymentGroupDefualt(isPaymentActive = true) {
  const paymentGroup = {
    isPaymentActive: isPaymentActive,
    validateError: false,
    paymentGroupNumber: 0,
    paymentGroupDate: new Date(),
    paymentTransactionBankAccountList: [] as any[],
    paymentTransactionChartOfAccountList: [] as any[],
    paymentTransactionDocumentList: [] as any[],
    paymentTransactionBankAccountDisabled: false,
    paymentTransactionBankAccountHidden: false,
    paymentTransactionChartAccountDisabled: false,
    paymentTransactionChartAccountHidden: true,
    paymentTransactionChartAccountActived: false,
    paymentTransactionDocumentDisabled: false,
    paymentTransactionDocumentHidden: true,
    paymentTransactionDocumentActived: false,
    disabled: false,
    hidden: false,
    whtPayment: {
      isWht: false,
      pndTypeId: 0,
      whtAmountTypeId: 0,
      whtAmount: 0,
      disabled: false,
      hidden: false,
    },
    paymentTransactionBankAccountTotal: 0,
    paymentTransactionChartAccountTotal: 0,
    paymentTransactionDocumentTotal: 0,
    paymentGroupTotal: 0,
    paymentGroupWhtTotal: 0,
    paymentGroupTotalWithOutWht: 0,
    paymentTransactionBankAccountTotalWithWht: 0,
    paymentOption: PaymentOption.Standard,
    paymentTransactionBankAccountTempList: [] as any[],
  };
  paymentGroup.paymentTransactionBankAccountList.push(GetCreatePaymentTransactionBankAccountDefault());
  paymentGroup.paymentTransactionChartOfAccountList.push(GetCreatePaymentTransactionChartAccountDefault());
  paymentGroup.paymentTransactionDocumentList.push(GetCreatePaymentTransactionDocumentDefault());
  return paymentGroup;
}

export function GetCreateTransactionPaymentDefualt(isPaymentActive = true) {
  const payment = {
    hidden: false,
    disabled: false,
    isValidateError: false,
    paymentGroupList: [] as any[],
    paymentAllGroupTotal: 0,
  };
  payment.paymentGroupList.push(GetCreateTransactionPaymentGroupDefualt(isPaymentActive));
  return payment;
}

export function GetPaymentInOutFlowType(transactionType: TransactionType, financeType: FinanceType) {
  let paymentInOutFlowType = PaymentInOutFlowType.CashIn;
  if (
    (transactionType === TransactionType.CreditNote && financeType === FinanceType.InFlow) ||
    (transactionType !== TransactionType.CreditNote && financeType === FinanceType.OutFlow)
  ) {
    paymentInOutFlowType = PaymentInOutFlowType.CashOut;
  }
  return paymentInOutFlowType;
}

function GetPaymentWhtOption() {
  return [
    {
      name: "0.75%",
      value: GetWhtAmountValue(WhtAmountType.ZeroPointSevenFive),
      type: WhtAmountType.ZeroPointSevenFive,
    },
    { name: "1%", value: GetWhtAmountValue(WhtAmountType.OnePercent), type: WhtAmountType.OnePercent },
    {
      name: "1.5%",
      value: GetWhtAmountValue(WhtAmountType.OnePointFivePercent),
      type: WhtAmountType.OnePointFivePercent,
    },
    { name: "2%", value: GetWhtAmountValue(WhtAmountType.TwoPercent), type: WhtAmountType.TwoPercent },
    { name: "3%", value: GetWhtAmountValue(WhtAmountType.ThreePercent), type: WhtAmountType.ThreePercent },
    { name: "5%", value: GetWhtAmountValue(WhtAmountType.FivePercent), type: WhtAmountType.FivePercent },
    { name: "10%", value: GetWhtAmountValue(WhtAmountType.TenPercent), type: WhtAmountType.TenPercent },
    {
      name: "15%",
      value: GetWhtAmountValue(WhtAmountType.FifteenPercent),
      type: WhtAmountType.FifteenPercent,
    },
    { name: "กำหนดเอง", value: GetWhtAmountValue(WhtAmountType.Custom), type: WhtAmountType.Custom },
  ];
}

export function DoGetPaymentWhtOption() {
  return GetPaymentWhtOption();
}

export function GetWhtPaymentPercent(
  subTotalForCalculateWht: any,
  transactionWhtTotal: any,
  transactionNetAmount: any,
  paymentNetAmount: any
) {
  const whtPercentList = GetPaymentWhtOption();
  const whtAmountList: any = [];
  for (const whtPercent of whtPercentList) {
    if (whtPercent.type !== WhtAmountType.Custom) {
      const _currentWHTAmount = (
        peakUtility.PeakOperatorDivide(paymentNetAmount, transactionNetAmount) *
        peakUtility.PeakOperatorDivide(peakUtility.PeakOperatorMultiply(subTotalForCalculateWht, whtPercent.value), 100)
      ).ToAccountingRoundUp();
      whtAmountList.push({ whtType: whtPercent.type, amount: _currentWHTAmount });
    }
  }
  let whtAmountType = WhtAmountType.Custom;
  for (const whtAmount of whtAmountList) {
    if (
      !isNaN(whtAmount.amount) &&
      whtAmount.amount.ToNumber() !== 0 &&
      whtAmount.amount.ToNumber() === transactionWhtTotal.ToNumber()
    ) {
      whtAmountType = whtAmount.whtType;
      break;
    }
  }
  return whtAmountType;
}

function CalculateWhtByPercent(
  transactionNetAmount: any,
  subTotalForCalculateWht: any,
  paymentNetAmount: any,
  whtPercent: any
) {
  let whtAmount = 0;
  const whtDeductType: any = WhtDeductType.WitholdAtSource;
  switch (whtDeductType) {
    case WhtDeductType.PayEveryTime:
      whtAmount = 0;
      break;
    case WhtDeductType.PayOneTime:
      whtAmount = 0;
      break;
    default:
      if (paymentNetAmount != 0 && transactionNetAmount != 0) {
        whtAmount = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(paymentNetAmount, transactionNetAmount),
          peakUtility.PeakOperatorDivide(peakUtility.PeakOperatorMultiply(subTotalForCalculateWht, whtPercent), 100)
        );
      }
      break;
  }
  return whtAmount;
}

export function CalculateWhtAmount(transactionNetAmount: any, subTotalForCalculateWht: any, paymentGroup: any) {
  if (paymentGroup.whtPayment.isWht) {
    if (paymentGroup.whtPayment.whtAmountTypeId !== WhtAmountType.Custom) {
      const whtPercent = GetWhtAmountValue(paymentGroup.whtPayment.whtAmountTypeId);
      paymentGroup.whtPayment.whtAmount = CalculateWhtByPercent(
        transactionNetAmount,
        subTotalForCalculateWht,
        paymentGroup.paymentGroupTotal,
        whtPercent
      ).FormatMoney();
    }
  }
}

export function OnChangeWht(paymentGroup: any, isFromEvent = false, isReturnWhtAmountToPayment = false) {
  if (paymentGroup.whtPayment.isWht) {
    paymentGroup.paymentTransactionBankAccountList[0].paymentAmount = peakUtility
      .PeakOperatorSubtract(
        paymentGroup.paymentTransactionBankAccountList[0].paymentAmount,
        paymentGroup.whtPayment.whtAmount
      )
      .FormatMoney();
  } else {
    paymentGroup.paymentTransactionBankAccountList[0].paymentAmount = peakUtility
      .PeakOperatorAdd(
        paymentGroup.paymentTransactionBankAccountList[0].paymentAmount,
        paymentGroup.whtPayment.whtAmount
      )
      .FormatMoney();
    if (isFromEvent) {
      paymentGroup.whtPayment.whtAmount = 0;
    }
  }
}

function CalculatePaymentGroupSummary(paymentGroup: any) {
  paymentGroup.paymentTransactionBankAccountTotal = 0;
  paymentGroup.paymentTransactionChartAccountTotal = 0;
  paymentGroup.paymentTransactionDocumentTotal = 0;
  if (paymentGroup.paymentTransactionBankAccountList) {
    paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransaction: any) => {
      paymentGroup.paymentTransactionBankAccountTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionBankAccountTotal,
        paymentTransaction.paymentAmount.ToNumber()
      );
    });
  }
  if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
    paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentTransaction: any) => {
      paymentGroup.paymentTransactionChartAccountTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionChartAccountTotal,
        peakUtility.PeakOperatorMultiply(paymentTransaction.adjustValue, paymentTransaction.paymentAmount.ToNumber())
      );
    });
  }
  if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
    paymentGroup.paymentTransactionDocumentList.forEach((paymentTransaction: any) => {
      paymentGroup.paymentTransactionDocumentTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionDocumentTotal,
        paymentTransaction.paymentAmount.ToNumber()
      );
    });
  }
  paymentGroup.paymentGroupWhtTotal = paymentGroup.whtPayment.isWht ? paymentGroup.whtPayment.whtAmount : 0;
  paymentGroup.paymentGroupTotal = peakUtility.PeakOperatorAdd(
    peakUtility.PeakOperatorAdd(
      paymentGroup.paymentTransactionBankAccountTotal,
      paymentGroup.paymentTransactionChartAccountTotal
    ),
    peakUtility.PeakOperatorAdd(paymentGroup.paymentTransactionDocumentTotal, paymentGroup.paymentGroupWhtTotal)
  );
  paymentGroup.paymentGroupTotalWithOutWht = peakUtility.PeakOperatorSubtract(
    paymentGroup.paymentGroupTotal,
    paymentGroup.paymentGroupWhtTotal
  );
  paymentGroup.paymentTransactionBankAccountTotalWithWht = peakUtility.PeakOperatorAdd(
    paymentGroup.paymentTransactionBankAccountTotal,
    paymentGroup.paymentGroupWhtTotal
  );
}

function ValidationPaymentGroup(paymentGroup: any) {
  let paymentGroupChartAccountValidateError = false;
  if (paymentGroup.paymentTransactionChartAccountActived) {
    paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentTransactionChartAccount: any) => {
      if (
        paymentTransactionChartAccount.paymentAmount.ToNumber() < 0 ||
        paymentTransactionChartAccount.accountId == 0
      ) {
        paymentTransactionChartAccount.inputValidationError = true;
      } else {
        paymentTransactionChartAccount.inputValidationError = false;
      }
    });
    paymentGroupChartAccountValidateError =
      paymentGroup.paymentTransactionChartOfAccountList.find(
        (paymentTransactionChartAccount: any) => paymentTransactionChartAccount.inputValidationError == true
      ) === undefined
        ? false
        : true;
  }
  paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransactionBankAccount: any) => {
    if (
      paymentTransactionBankAccount.paymentAmount.ToNumber() < 0 ||
      paymentTransactionBankAccount.bankAccountId == 0
    ) {
      paymentTransactionBankAccount.inputValidationError = true;
    } else {
      paymentTransactionBankAccount.inputValidationError = false;
    }
  });
  const paymentGroupBankAccountValidateError =
    paymentGroup.paymentTransactionBankAccountList.find(
      (paymentTransactionBankAccount: any) => paymentTransactionBankAccount.inputValidationError == true
    ) === undefined
      ? false
      : true;
  return paymentGroupBankAccountValidateError || paymentGroupChartAccountValidateError;
}

export function CalculateAllPaymentGroupSummary(payment: any) {
  payment.paymentAllGroupTotal = 0;
  if (payment.paymentGroupList) {
    payment.paymentGroupList.forEach((paymentGroup: any) => {
      if (paymentGroup.isPaymentActive) {
        CalculatePaymentGroupSummary(paymentGroup);
        payment.paymentAllGroupTotal = peakUtility.PeakOperatorAdd(
          payment.paymentAllGroupTotal,
          paymentGroup.paymentGroupTotal
        );
        paymentGroup.validateError = ValidationPaymentGroup(paymentGroup);
      }
    });
  }
}

function IsTransactionCanUsePndType(transactionTypeId: any, financeTypeId: any) {
  let isTransactionCanUsePndType = false;
  if (transactionTypeId === TransactionType.Invoice && financeTypeId === FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === TransactionType.BillingNote && financeTypeId === FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === TransactionType.CreditNote && financeTypeId === FinanceType.InFlow) {
    isTransactionCanUsePndType = true;
  }
  return isTransactionCanUsePndType;
}

function GetPndTypeByTaxIncomeType(taxIncomeTypeId: TaxIncomeType) {
  let pndType = PndType.PND3;
  switch (taxIncomeTypeId) {
    case TaxIncomeType.TaxIncomeType40_1_1:
    case TaxIncomeType.TaxIncomeType40_1_2:
    case TaxIncomeType.TaxIncomeType40_12:
    case TaxIncomeType.TaxIncomeType40_2:
      pndType = PndType.PND1kor;
      break;
    case TaxIncomeType.TaxIncomeType40_3:
    case TaxIncomeType.TaxIncomeType40_4_A:
    case TaxIncomeType.TaxIncomeType40_4_B:
    case TaxIncomeType.TaxIncomeType40_4_C:
    case TaxIncomeType.TaxIncomeType40_4_D:
    case TaxIncomeType.TaxIncomeType40_4_E:
    case TaxIncomeType.TaxIncomeType40_4_F:
    case TaxIncomeType.TaxIncomeType40_4_G:
      pndType = PndType.PND2;
      break;
  }
  return pndType;
}

export function GetSuggestionPndType(transaction: any) {
  let pndType = PndType.None;
  if (IsTransactionCanUsePndType(transaction.transactionType, transaction.financeType)) {
    if (IsOrdinaryPerson(transaction.contact.contactType)) {
      let totalPndType3 = 0;
      let totalPndType2 = 0;
      let totalPndType1Kor = 0;
      const transactionItemModel: any = DoGetTransactionItemList(transaction);
      const transactionItemSummary = DoGetTransactionItemSummary(transaction);
      for (const transactionItem of transactionItemModel.transactionItemList) {
        if (!transactionItem.isDescriptionOnly) {
          const transactionItemPndType = GetPndTypeByTaxIncomeType(transactionItem.taxIncomeTypeId);
          if (transactionItemSummary.isNoneOrNotSpecifyWht) {
            if (transactionItemPndType === PndType.PND1kor) {
              totalPndType1Kor += transactionItem.netAmount;
            } else if (transactionItemPndType === PndType.PND2) {
              totalPndType2 += transactionItem.netAmount;
            } else if (transactionItemPndType === PndType.PND3) {
              totalPndType3 += transactionItem.netAmount;
            }
          } else {
            if (transactionItemPndType === PndType.PND1kor) {
              totalPndType1Kor += transactionItem.whtAmount;
            } else if (transactionItemPndType === PndType.PND2) {
              totalPndType2 += transactionItem.whtAmount;
            } else if (transactionItemPndType === PndType.PND3) {
              totalPndType3 += transactionItem.whtAmount;
            }
          }
        }
      }
      if (totalPndType3 < totalPndType1Kor && totalPndType2 <= totalPndType1Kor) {
        pndType = PndType.PND1kor;
      } else if (totalPndType2 > totalPndType1Kor && totalPndType2 > totalPndType3) {
        pndType = PndType.PND2;
      } else {
        pndType = PndType.PND3;
      }
    } else {
      pndType = PndType.PND53;
    }
  }
  return pndType;
}
